
$(document).ready(function () {

  var userId = document.getElementById("customerId").value;
  var customerEmail = document.getElementById("customerEmail").value;
  if (!userId) {
    window.location.href =
      location.protocol +
      "//" +
      location.host +
      window.Shopify.routes.root +
      "/account/login";
  }
  var states = [];
  var modal;
  var bookingInfo = null;
  var isBookingForSomeoneElse = false;
  var noOfDays = 1;
  var selectedState = "";
  var selectedStateLabel = "";
  var styles = [
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [
        {
          color: "#e9e9e9",
        },
        {
          lightness: 17,
        },
      ],
    },
    {
      featureType: "landscape",
      elementType: "geometry",
      stylers: [
        {
          color: "#f5f5f5",
        },
        {
          lightness: 20,
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#ffffff",
        },
        {
          lightness: 17,
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#ffffff",
        },
        {
          lightness: 29,
        },
        {
          weight: 0.2,
        },
      ],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry",
      stylers: [
        {
          color: "#ffffff",
        },
        {
          lightness: 18,
        },
      ],
    },
    {
      featureType: "road.local",
      elementType: "geometry",
      stylers: [
        {
          color: "#ffffff",
        },
        {
          lightness: 16,
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [
        {
          color: "#f5f5f5",
        },
        {
          lightness: 21,
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [
        {
          color: "#dedede",
        },
        {
          lightness: 21,
        },
      ],
    },
    {
      elementType: "labels.text.stroke",
      stylers: [
        {
          visibility: "on",
        },
        {
          color: "#ffffff",
        },
        {
          lightness: 16,
        },
      ],
    },
    {
      elementType: "labels.text.fill",
      stylers: [
        {
          saturation: 36,
        },
        {
          color: "#333333",
        },
        {
          lightness: 40,
        },
      ],
    },
    {
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [
        {
          color: "#f2f2f2",
        },
        {
          lightness: 19,
        },
      ],
    },
    {
      featureType: "administrative",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#fefefe",
        },
        {
          lightness: 20,
        },
      ],
    },
    {
      featureType: "administrative",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#fefefe",
        },
        {
          lightness: 17,
        },
        {
          weight: 1.2,
        },
      ],
    },
  ];
  var k = "LLLLLLL";
  var stateLabels = [
    
    {
      name: "Arizona",
      value: "AZ",
    },
    {
      name: "Connecticut",
      value: "CT",
    },
    {
      name: "District Of Columbia",
      value: "DC",
    },
  
    {
      name: "Florida",
      value: "FL",
    },
    {
      name: "Guam",
      value: "GU",
    },
    {
      name: "Indiana",
      value: "IN",
    },
    {
      name: "Louisiana",
      value: "LA",
    },
   
    {
      name: "Maryland",
      value: "MD",
    },
    {
      name: "Massachusetts",
      value: "MA",
    },
    {
      name: "Minnesota",
      value: "MN",
    },
    {
      name: "New Mexico",
      value: "NM",
    },
    {
      name: "New York",
      value: "NY",
    },
    {
      name: "North Carolina",
      value: "NC",
    },
   
    {
      name: "Rhode Island",
      value: "RI",
    },
    {
      name: "Texas",
      value: "TX",
    },
  ];

  var addOnPacks = [
    {
      product: "classic",
      addons: ["addon-starter-kit"],
    },
    {
      product: "classic-enhanced-course",
      addons: ["addon-starter-kit"],
    },
    {
      product: "volume-course",
      addons: ["addon-starter-kit"],
    },
    {
      product: "volume-enhanced-course",
      addons: ["addon-starter-kit"],
    },
  ];


// Preselected data
var savedDataString = localStorage.getItem('selectedData');

if (savedDataString) {
  // Convert the data string back to an object
  var savedData = JSON.parse(savedDataString);
  // Use the retrieved data
  for (let i=0 ; i < stateLabels.length ; i++){
    if ( savedData.state === stateLabels[i].value){
      savedData['stateName'] = stateLabels[i].name;
    }
  }
} else {
  var savedData = null;
}




  async function getStates() {
    return new Promise((resolve) => {
      var settings = {
        url: window.URL + "api/stateRegulations/all",
        method: "GET",
        timeout: 0,
        "Content-Type": "application/json",
      };

      $.ajax(settings).done(function (response) {
        if (response) {
          states = response.res;
          resolve("resolved");
        }
      });
    });
  }

  async function getModelProductDetails() {
    return new Promise((resolve) => {
      $.get(
        window.Shopify.routes.root + "products/model.js",
        function (data, status) {
          if (data) {
            modal = data;
            resolve("resolved");
          }
        }
      );
    });
  }

  async function getAddonProducts(val) {
    return new Promise((resolve) => {
      $.get(
        window.Shopify.routes.root + "products/" + val + ".js",
        function (data, status) {
          if (data) {
            resolve(data);
          }
        }
      );
    });
  }

  humanize_format = function humanize(num) {
    if (typeof num == "undefined") return;
    if (num % 100 >= 11 && num % 100 <= 13) return num + "th";

    switch (num % 10) {
      case 1:
        return num + "st";
      case 2:
        return num + "nd";
      case 3:
        return num + "rd";
    }
    return num + "th";
  };
  var lc = localStorage.getItem("current-course");
  if (!lc) {
    window.location.href =
      location.protocol +
      "//" +
      location.host +
      window.Shopify.routes.root +
      "404";
  }
  lc = JSON.parse(lc);
  var currentAddOn = addOnPacks.find(function (item) {
    return item["product"] === lc["handle"];
  });

  var Course = Backbone.Model.extend({
    defaults: {
      title: "",
      location: "",
      startDate: "",
      endDate: "",
      price: "",
      addOnPrices: 0,
      totalPrice: 0,
      image: "",
      progress: 0,
      id: 0,
      handle: "",
    },
  });

  var StepList = Backbone.Model.extend({
    defaults: { name: "", active: false, complete: false },
  });
  //Define schema
  var Step = Backbone.Model.extend({
    defaults: {
      title: "",
      description: {
        subTitle: "",
        title: "",
        description: "",
        qa: [
          {
            question: "",
            answer: "",
          },
        ],
        type: 0,
      },
    },
  });
  // Assign Schema to collection
  var StepCollection = Backbone.Collection.extend({
    model: Step,
  });
  var StepListCollection = Backbone.Collection.extend({
    model: StepList,
  });

  var stepsTemplate = [
    //0
    {
      title: "booking-for-myself",
      description: {
        subTitle: "Start your journey",
        title: "Secure your spot for our Classic or Volume Course",
        description:
          "Get a head start on your lash career with the most comprehensive one-day Eyelash Extension Certification Course available. Join us for a thorough 8.5-hour day of training and a unique blend of theory and hands-on training from knowledgeable, passionate, and student-centered instructors.\n" +
          "\t\n" +
          "We’re committed to the safety of lash professionals and lash clients.\n" +
          "\t\n" +
          "Please review course requirements, the Lavish Lashes® code of ethics, and our eight pillars of safety before booking a class\n" +
          "\t\n" +
          "If you have questions, please feel free to reach out to our team. We’re happy to help!\n",

        qa: [],
        type: 1,
      },
      question: {
        value: "",
      },
      nextStepIndex: 0,
    },
    //1
    {
      title: "other-person-information",
      description: {
        subTitle: "Introduction",
        title: "What describes you the most?",
        description:
          "Ready to learn the skills of a PRO lash artist? Before we get started, help us learn more about you and where you are on your lash journey - or if you’re booking on behalf of a beauty business or beauty school, that’s cool too! We’d love to learn more about your lash journey.",
        qa: [],
        type: 1,
      },
      question: {
        value: {
          firstName: "",
          lastName: "",
          phoneNumber: "",
          email: "",
        },
        validated: false,
      },
    },
    //2
    {
      title: "introduction-person",
      description: {
        subTitle: "Introduction",
        title: "What describes you the most?",
        description:
          "Before registering for Lavish Lashes trainings and/or applying eyelash extensions, it is incumbent upon you to know and abide by the laws of your state regarding eyelash extensions",
        qa: [
          {
            question: "I dont see an option that fits my description",
            answer:
              "Selecting other will indicate that you do not fit any of the descriptions above",
          },
        ],
        type: 0,
      },
      active: false,
      flag: true,
      question: {
        attribute: "introduction-person",
        value: "",
        options: [
          "a Student",
          "Enrolled in a beauty school program",
          "a Salon/Spa Owner/Authorized Representative",
          "a Beauty School Owner / Authorized Representative",
          "a Beauty School Instructor / Authorized Representative",
          "a Licensed Esthetician",
          "a Licensed Cosmetologist",
          "Other",
        ],
      },
    },
    //3
    {
      title: "state-regulation",
      description: {
        subTitle: "Know your state’s regulations",
        title:
          "It is incumbent upon you to know and abide by the laws of your state.",
        description:
          " Just a friendly reminder, it's important for you to know and follow the rules and regulations in your state.",
        qa: [
          {
            question: "Why is it important where I conduct my business?",
            answer:
              "Every state has its own regulations for applying eyelash extensions, and it is important to be sure that you are following the proper guidelines to ensure safety and quality. Depending on your location, different rules may apply, so it's essential to understand the laws in your area before beginning any lash application procedure.",
          },
          {
            question:
              "What’s the difference between licensure and certification?",
            answer:
              "A Lavish Lashes certification recognizes you as a certified Lavish Lashes Professional within the industry. Our certification does not, however, automatically provide you a license to offer lash extension services to clients for a fee in the state of your practice.\n" +
              "\t\n" +
              "Most states require licensure to offer beauty or body treatments.\n" +
              "\t\n" +
              "You must know and abide by the laws of your state regarding eyelash extensions.\n" +
              "\t\n" +
              "For your convenience, we have created a summary of state laws and regulations regarding eyelash extensions with the contact information for each state authority. Please note that this summary is not a comprehensive list of state laws and regulations. We recommend reviewing the website of your local health authority for the most up-to-date information.\n",
          },
          {
            question:
              "Where can I find a list of states that don't require licenses?",
            answer:
              "You can review the full list of state requirements in our homepage by going to state regulations",
          },
          {
            question: "Can I become certified with an expired license?",
            answer:
              "You can register for the Lavish Lashes® course if your license is expired or you are currently in process of obtaining your license. \n" +
              "\n" +
              "You can also book the course as a former esthetician or cosmetologist, if you have partaken in infection control training within the last two years. \n" +
              "\n" +
              "Alternatively, you can speak with our team for more information about infection control online courses for professionals you can take beforehand to satisfy our prerequisites.\n",
          },
          {
            question:
              "What happens if I move forward without the required license?",
            answer:
              "The Lavish Lashes® certification provides you with the necessary specialized training and unique skills to perform safe lash extension applications. However, this does NOT automatically imply or guarantee that you can provide lash extension services for a fee in your state.\n" +
              "\n" +
              "In many states, licensed cosmetologists and estheticians are legally allowed to perform lash extension services without specific training in lash extension or board testing.\n" +
              "\n" +
              "However, at Lavish Lashes®, we recommend certification in combination with state licensure to ensure consumer safety and the best customer experience. \n",
          },
        ],
        type: 0,
      },
      active: false,
      question: {
        preData : (savedData === null) ? false : true,
        state: {
          attribute: "State",
          value: (savedData === null) ? '' : savedData.stateName ,
          options: {},
        },
        qualifications: {
          attribute: "Qualified License",
          value: "",
        },
        validated: false,
      },
    },
    //4
    {
      title: "pick-date",
      description: {
        subTitle: "Pick a Date",
        title: "We have schedules that works for you.",
        description:
          "Lavish Lashes® prides itself on its superior training and certification program. The beauty and health professionals that attend our certification workshops receive the highest caliber training by the most competent instructors in the industry. At Lavish Lashes® just showing up for training does not guarantee certification. Successful completion of the course requires that you demonstrate comprehension of the key concepts and theory of lash extensions and that you can perform the application technique in a safe, efficient, and confident manner.",
        qa: [
          {
            question:
              "How many instructors are present during training for each student?",
            answer:
              "Both our Classic Course and the Volume Course have an industry-leading student-instructor ratio of 1:4.",
          },
          {
            question: "Can I exchange the free kit for something else?",
            answer:
              "You will need your Lavish® Kits for in-class practice. However, if you decide not to proceed with your training, you may exchange your kit for Lavish Lashes® professional products of equal or lesser value.",
          },
          {
            question: "When will I receive my kit?",
            answer:
              "Your kit will be shipped within one business day of purchase and should arrive before your training begins. Please double-check your address before submitting your order, and keep in mind that you will need your kit for training and certification.\n" +
              "\n" +
              "If your kit does not arrive in time for your training day, do not worry. Your Lavish Lashes® instructor will provide the materials needed for certification. Let our team know if your kit has not arrived at least 48 hours before the training day.\n",
          },
        ],
        type: 0,
      },
      question: {
        courseTier: "second",
        course: {},
        title: lc.title,
        courseId: lc.id,
        dates: [],
        selectedLocation: "",
        modelIsOpen: false,
        selectedClassSlot: [],
        filteredClasses: [],
        selectedDate: "",
        value: "",
        total: 0,
        classes: [
          {
            _id: "20010100012121001",
            startDate: "2022/11/22",
            startingDate: "Introduction",
            endDate: "",
            time: "07:00 - 11:00",
            courseName: "",
            location: "New York",
            address: "3700 W Flamingo Rd,  Las Vegas, NV 89103, United States",
            noOfDays: "2",
            noOfSeats: "5",
            course_id: 3,
          },
          {
            _id: "20010100012121001",
            startDate: "2022/12/01",
            startingDate: "Introduction",
            endDate: "",
            time: "09:00 - 12:00",
            courseName: "",
            location: "Florida",
            address: "3700 W Flamingo Rd,  Las Vegas, NV 89103, United States",
            noOfDays: "2",
            noOfSeats: "5",
            course_id: 3,
          },
        ],
        validated: false,
      },
    },
    //5
    {
      title: "modal-requirment",
      description: {
        subTitle: "Model Requirement",
        title: "Don’t have a model? Lavish Lashes got you covered",
        description:
          "Experienced models who are comfortable posing for the camera and have a portfolio to show for it. These models can be used to enhance social media/website presence, developing a Lavish portfolio, or for other marketing needs.",
        qa: [
          {
            question: "Who makes a good model?",
            answer:
              "Good candidates for models have the following:\n" +
              "- fairly straight lashes (curly lashes are more challenging to work with)\n" +
              "- healthy lashes (short and/or fine lashes are more challenging to work with)\n" +
              "- healthy eyes\n" +
              "- non-sensitive skin around the eye and lash line\n",
          },
          {
            question:
              "If I take the two-day Classic and Classic Advanced training or Volume and Volume Advanced training , should I have the same model for both days?",
            answer:
              "Ideally, we would recommend working on the same model on both days. However, we realize it may not always be possible. You may use different models on each day, or the same.",
          },
          {
            question: "What times should my model be present?",
            answer:
              "You will need your model at the following times:\n" +
              "\n" +
              "Classic: 2:30 pm - 5 pm \n" +
              "Advanced Classic (Day 2): 8:30 - 2 pm\n" +
              "Volume: 1:30 pm - 5 pm \n" +
              "Advanced Volume (Day 2): 8:45 - 2:30 pm\n",
          },
          {
            question: "Will my model receive a full set of eyelash extensions?",
            answer:
              "No. Models typically receive a set of accent extensions (about 5 - 15 on each eye) and not a complete set of 50 lashes per eye. Please note that the objective of the class is not the number of lash extensions you can place on your model, but to learn the safety and quality of the application",
          },
          {
            question: "Will we remove the extensions after class?",
            answer:
              "No. In the unlikely event your model prefers not to keep the extensions applied during training, you will be trained on how to remove extensions and can offer to remove them at a later time.",
          },
        ],
        type: 0,
      },
      active: false,
      question: {
        noOfDays: 0,
        value: {
          "will-provide": [],
          need: [],
        },
        courses: [],
        modal: "",
        total: 0,
        validated: false,
      },
    },
    //6
    {
      title: "modal-information",
      description: {
        subTitle: "Model Requirment",
        title: "Don’t have a model? Lavish Lashes got you covered",
        description:
          "Through our new Model Match-up Program, you can connect with a volunteer model who understands you are newly certified and will be patient while you build up your speed.",
        qa: [
          {
            question: "Who makes a good model?",
            answer:
              "Good candidates for models have the following:\n" +
              "- fairly straight lashes (curly lashes are more challenging to work with)\n" +
              "- healthy lashes (short and/or fine lashes are more challenging to work with)\n" +
              "- healthy eyes\n" +
              "- non-sensitive skin around the eye and lash line\n",
          },
          {
            question:
              "If I take the two-day Classic and Classic Advanced training, should I have the same model for both days?",
            answer:
              "Ideally, we would recommend working on the same model on both days. However, we realize it may not always be possible. You may use different models on each day, or the same.",
          },
          {
            question: "What times should my model be present?",
            answer:
              "You will need your model at the following times:\n" +
              "\n" +
              "Classic: 2:30 pm - 5 pm \n" +
              "Advanced Classic (Day 2): 8:30 - 2 pm\n" +
              "Volume: 1:30 pm - 5 pm \n" +
              "Advanced Volume (Day 2): 8:45 - 2:30 pm\n",
          },
          {
            question: "Will my model receive a full set of eyelash extensions?",
            answer:
              "No. Models typically receive a set of accent extensions (about 5 - 15 on each eye) and not a complete set of 50 lashes per eye. Please note that the objective of the class is not the number of lash extensions you can place on your model, but to learn the safety and quality of the application",
          },
          {
            question: "Will we remove the extensions after class?",
            answer:
              "No. In the unlikely event your model prefers not to keep the extensions applied during training, you will be trained on how to remove extensions and can offer to remove them at a later time.",
          },
        ],
        type: 1,
      },
      question: {
        noOfModals: 2,
        startDate: "2021-10-01",
        value: [],
        need: [],
        validated: false,
      },
    },
    //7
    {
      title: "kits",
      description: {
        subTitle: "Toolkits",
        title: "Business building kits",
        description:
          "NOW SERVICES MORE CLIENTS! The perfect kit for beauty professionals that desire to be certified in Lavish Lashes® Eyelash Extensions but prefer to minimize their initial investment before taking their certification class. The Starter Kit provides enough lashes for approximately 250 applications and also includes a case of our signature silky mink lashes to integrate into your service offering. Once you have selected your kit, please remember to review the training schedule to reserve your class date",
        qa: [
          {
            question: "Does the Lavish Lashes Classic kit include a warranty?",
            answer:
              "The Lavish Lashes® Classic kit includes the standard Lavish Lashes® product warranty.",
          },
          {
            question: "Can I exchange the free kit for something else?",
            answer:
              "You will need your Lavish® Kits for in-class practice. However, if you decide not to proceed with your training, you may exchange your kit for Lavish Lashes® professional products of equal or lesser value.",
          },
          {
            question: "When will I receive my Lavish Lashes® kit?",
            answer:
              "Your kit will be shipped within one business day of purchase and should arrive before your training begins. Please double-check your address before submitting your order, and keep in mind that you will need your kit for training and certification.\n" +
              "\n" +
              "If your kit does not arrive in time for your training day, do not worry. Your Lavish Lashes® instructor will provide the materials needed for certification. Let our team know if your kit has not arrived at least 48 hours before the training day.\n",
          },
        ],
        type: 0,
      },
      question: {
        addOns: currentAddOn["addons"],
        value: [],
        items: [],
        total: 0,
        validated: false,
      },
    },
    //8
    {
      title: "final-summary",
      active: false,
      description: "hide",
      progress: "hide",
      question: {
        courseTitle: "classic",
        date: "Wednesday 18, May 2022 - Thursday 19 May 2022",
        time: "07:00 PM - 08:00PM (TimeZone)",
        loacftion: "Rio All-Suite Hotel",
        address: "3700 W Flamingo Rd,  Las Vegas, NV 89103,  United States",

        validated: false,
      },
      value: null,
    },
    //9
    {
      title: "inperson-training",
      description: {
        subTitle: "Exprience Level",
        title: "We want to capture",
        description:
          "Before registering for Lavish Lashes trainings and/or applying eyelash extensions, it is incumbent upon you to know and abide by the laws of your state regarding eyelash extensions",
        qa: [
          {
            question: "Why does it matter where I conduct my business?",
            answer: "Every state has its own regulations for applying eyelash extensions, and it is important to be sure that you are following the proper guidelines to ensure safety and quality. Depending on your location, different rules may apply, so it's essential to understand the laws in your area before beginning any lash application procedure.",
          },
          {
            question: "Why does it matter where I conduct my business?",
            answer: "Every state has its own regulations for applying eyelash extensions, and it is important to be sure that you are following the proper guidelines to ensure safety and quality. Depending on your location, different rules may apply, so it's essential to understand the laws in your area before beginning any lash application procedure",
          },
        ],
        type: 0,
      },
      question: {
        value: "",
        validated: false,
      },
    },
    //10
    {
      title: "previous-provider",
      description: {
        subTitle: "Exprience Level",
        title: "We want to capture",
        description:
          "Before registering for Lavish Lashes trainings and/or applying eyelash extensions, it is incumbent upon us to know if you’ve had any experiances in the industry to strat with",
        qa: [
          {
            question: "Why does it matter where I conduct my business?",
            answer: "Every state has its own regulations for applying eyelash extensions, and it is important to be sure that you are following the proper guidelines to ensure safety and quality. Depending on your location, different rules may apply, so it's essential to understand the laws in your area before beginning any lash application procedure.",
          },
          {
            question: "Why does it matter where I conduct my business?",
            answer: "Every state has its own regulations for applying eyelash extensions, and it is important to be sure that you are following the proper guidelines to ensure safety and quality. Depending on your location, different rules may apply, so it's essential to understand the laws in your area before beginning any lash application procedure",
          },
        ],
        type: 0,
      },
      question: {
        provider: {
          attribute: "provider",
          value: "",
          options: [
            "Lavish Lashes",
            "Xtreme Lashes",
            "NovaLash",
            "BorboletaPro",
            "Sugarlash Pro",
            "Lashbomb",
            "EBL",
            "Elleebana",
            "The Lash Professionals",
            "Bella Lash",
            "LBLA",
          ],
        },
        otherProvider: {
          attribute: "other-provider",
          value: "",
        },
        certficationAgreement: false,
        validated: false,
      },
    },
    //12
    {
      title: "course-requirment",
      description: {
        subTitle: "Exprience Level",
        title: "We want to capture",
        description:
          "Before registering for Lavish Lashes trainings and/or applying eyelash extensions, it is incumbent upon you to know and abide by the laws of your state regarding eyelash extensions",
        qa: [
          {
            question: "Why does it matter where I conduct my business?",
            answer: "Every state has its own regulations for applying eyelash extensions, and it is important to be sure that you are following the proper guidelines to ensure safety and quality. Depending on your location, different rules may apply, so it's essential to understand the laws in your area before beginning any lash application procedure.",
          },
          {
            question: "Why does it matter where I conduct my business?",
            answer: "Every state has its own regulations for applying eyelash extensions, and it is important to be sure that you are following the proper guidelines to ensure safety and quality. Depending on your location, different rules may apply, so it's essential to understand the laws in your area before beginning any lash application procedure",
          },
        ],
        type: 0,
      },
      active: false,
      question: {
        value: "",
        validated: false,
      },
    },
    //13
    {
      title: "pick-date-stage-01",
      description: {
        subTitle: "Pick a Date",
        title: "We have schedules that works for you.",
        description:
          "Lavish Lashes® prides itself on its superior training and certification program. The beauty and health professionals that attend our certification workshops receive the highest caliber training by the most competent instructors in the industry. At Lavish Lashes® just showing up for training does not guarantee certification. Successful completion of the course requires that you demonstrate comprehension of the key concepts and theory of lash extensions and that you can perform the application technique in a safe, efficient, and confident manner.",
        qa: [
          {
            question: "Why in groups",
            answer: "Your Answers Here",
          },
          {
            question: "Can i exchange the free kit to something else?",
            answer: "Your Answers Here",
          },
          {
            question: "When will i get the kits?",
            answer: "Your Answers Here",
          },
        ],
        type: 0,
      },
      question: {
        courseTier: "first",
        title: lc.title,
        courseId: lc.id,
        course: {},
        dates: [],
        selectedLocation: "",
        modelIsOpen: false,
        selectedClassSlot: [] ,
        filteredClasses: [],
        selectedDate: '' ,
        value: "",
        classes: [],
        validated: false,
        total: 0,
      },
    },
    //14
    {
      title: "pick-date-stage-02",
      description: {
        subTitle: "Pick a Date",
        title: "We have schedules that works for you.",
        description:
          "Lavish Lashes® prides itself on its superior training and certification program. The beauty and health professionals that attend our certification workshops receive the highest caliber training by the most competent instructors in the industry. At Lavish Lashes® just showing up for training does not guarantee certification. Successful completion of the course requires that you demonstrate comprehension of the key concepts and theory of lash extensions and that you can perform the application technique in a safe, efficient, and confident manner.",
        qa: [
          {
            question: "Why in groups",
            answer: "Your Answers Here",
          },
          {
            question: "Can i exchange the free kit to something else?",
            answer: "Your Answers Here",
          },
          {
            question: "When will i get the kits?",
            answer: "Your Answers Here",
          },
        ],
        type: 0,
      },
      question: {
        courseTier: "third",
        title: lc.title,
        courseId: lc.id,
        course: {},
        dates: [],
        selectedLocation: "",
        modelIsOpen: false,
        selectedClassSlot: [],
        filteredClasses: [],
        selectedDate: "",
        value: "",
        classes: [],
        validated: false,
        total: 0,
      },
    },
    //11
    {
      title: "exprience-level",
      description: {
        subTitle: "Exprience Level",
        title: "Getting to know more about you",
        description:
          "Before registering for Lavish Lashes trainings and/or applying eyelash extensions, it is incumbent upon you to know and abide by the laws of your state regarding eyelash extensions",
        qa: [
          {
            question: "Why does it matter where I conduct my business?",
            answer: "Every state has its own regulations for applying eyelash extensions, and it is important to be sure that you are following the proper guidelines to ensure safety and quality. Depending on your location, different rules may apply, so it's essential to understand the laws in your area before beginning any lash application procedure.",
          },
          {
            question: "Why does it matter where I conduct my business?",
            answer: "Every state has its own regulations for applying eyelash extensions, and it is important to be sure that you are following the proper guidelines to ensure safety and quality. Depending on your location, different rules may apply, so it's essential to understand the laws in your area before beginning any lash application procedure",
          },
        ],
        type: 0,
      },
      active: false,
      question: {
        value: "",
        validated: false,
      },
    },

    {
      title: "specific-course",
      description: {
        subTitle: "Exprience Level",
        title: "We want to capture",
        description:
          "Before registering for Lavish Lashes trainings and/or applying eyelash extensions, it is incumbent upon you to know and abide by the laws of your state regarding eyelash extensions",
        qa: [
          {
            question: "Why does it matter where I conduct my business?",
            answer: "Every state has its own regulations for applying eyelash extensions, and it is important to be sure that you are following the proper guidelines to ensure safety and quality. Depending on your location, different rules may apply, so it's essential to understand the laws in your area before beginning any lash application procedure.",
          },
          {
            question: "Why does it matter where I conduct my business?",
            answer: "Every state has its own regulations for applying eyelash extensions, and it is important to be sure that you are following the proper guidelines to ensure safety and quality. Depending on your location, different rules may apply, so it's essential to understand the laws in your area before beginning any lash application procedure",
          },
        ],
        type: 0,
      },
      active: false,
      question: {
        options: {},
        value: {},
        validated: false,
      },
    },
  ];

  var cc,
    ce,
    vc,
    ve = null;

  var steps = new StepCollection();

  var stepList = new StepListCollection([
    {
      name: "Introduction",
      active: false,
      complete: false,
    },
    {
      name: "State Regulations",
      active: false,
      complete: false,
    },
    {
      name: "Pick a Date",
      active: false,
      complete: false,
    },
    {
      name: "Model Requirement",
      active: false,
      complete: false,
    },
    {
      name: "Lash Business Starter Kits",
      active: false,
      complete: false,
    },
    {
      name: "Summary",
      active: false,
      complete: false,
    },
  ]);

  steps.add(stepsTemplate[0]);

  var c = new Course({
    title: lc.title,
    location: "",
    startDate: "",
    startTime: "",
    image: lc.featured_image,
    price: Number(lc.price / 100).toFixed(2),
    progress: 0,
    addOnPrices: 0,
    totalPrice: 0,
    id: lc.id,
    handle: lc.handle,
  });
  var currentIndex = 1;
  //Main App
  var ApplicationView = Backbone.View.extend({
    // 'el' uses '#mydiv' as the view reference
    el: $("#AppContainer"),
    model: steps,
    index: 0,
    step: 0,
    // 'template' provides access to instance data when rendering the view
    template: _.template($("#AppTpl").html()),
    // This function is called when the view is instantiated
    initialize: async function () {
      cc = JSON.parse(await getAddonProducts("classic"));
      ce = JSON.parse(await getAddonProducts("classic-enhanced-course"));
      vc = JSON.parse(await getAddonProducts("volume-course"));
      vconc = JSON.parse(await getAddonProducts("volume-conversion-course"));
      conc = JSON.parse(await getAddonProducts("conversion-course"));
      ve = JSON.parse(await getAddonProducts("volume-enhanced-course"));
      //model infomations
      cc.model = JSON.parse(await getAddonProducts("model-classic-course"));
      ce.model = JSON.parse(
        await getAddonProducts("model-classic-enchanced-course")
      );
      vc.model = JSON.parse(await getAddonProducts("model-volume-course"));
      ve.model = JSON.parse(
        await getAddonProducts("model-volume-enhanced-course")
      );
      var m = this.model.at(this.index);
      this.desc = new DescribtionView({
        parent: this,
        model: m.get("description"),
      });
      this.steps = new StepsView({ parent: this, model: stepList });

      this.progress = new ProgressView({ parent: this, model: c });
      this.render();
      this.listenTo(this.model, "change", this.render);
      this.listenTo(
        Backbone,
        "next-event",
        function (data) {
          this.nextStep(data);
        },
        this
      );

      this.listenTo(
        Backbone,
        "prev-event",
        function (data) {
          this.prevStep(data);
        },
        this
      );
    },
    nextStep: function (data) {
      var t = stepsTemplate[data["nextStepIndex"]];
      var found = steps.find(function (item) {
        return item.get("title") === t["title"];
      });
      if (!found) {
        //Change of redirection
        if (this.index + 1 < steps.length) {
          var lastItem = steps.at(steps.length - 1);
          steps.remove(lastItem);
        }
        steps.add(stepsTemplate[data["nextStepIndex"]]);
      }
      //update old step data
      var m = this.model.at(this.index);
      m.set("question", data);
      this.index = this.index + 1;
      currentIndex += 1;
      this.step = data["nextStepIndex"];
      var stepInd = stepsTemplate.findIndex(function (item) {
        return item["title"] === m.get("title");
      });
      //new step
      m = this.model.at(this.index);

      m.set("prevStep", stepInd);

      this.desc = new DescribtionView({
        parent: this,
        model: m.get("description"),
      });
      this.steps = new StepsView({ parent: this, model: stepList });
      this.render();
    },
    prevStep: function (data) {
      var m = this.model.at(this.index);
      m.set("question", data);
      this.step = m.get("prevStep");
      this.index = this.index - 1;
      currentIndex -= 1;
      var pstep = this.model.at(this.index);
      this.desc = new DescribtionView({
        parent: this,
        model: pstep.get("description"),
      });
      this.steps = new StepsView({ parent: this, model: stepList });
      this.render();
    },
    updateStepStatus: function (index) {
      var found = stepList.find(function (item) {
        return item.get("active") == true;
      });
      if (found) {
        found.set("active", false);
      }
      var i = stepList.at(index);
      i.set("active", true);
    },
    // 'render' provides the logic required to construct the view
    render: function () {
      this.$el.html(this.template());

      var m = this.model.at(this.index);
      //  this.ques = new finalSummaryView({parent:this, model:  m.get("question") })
      switch (this.step) {
        case 0:
          this.updateStepStatus(0);
          this.ques = new BookingMySelfView({
            parent: this,
            model: m.get("question"),
          });
          break;
        case 1:
          this.ques = new otherPersonDetailView({
            parent: this,
            model: m.get("question"),
          });
          break;
        case 2:
          this.ques = new IntroductionPersonView({
            parent: this,
            model: m.get("question"),
          });
          break;
        case 3:
          this.updateStepStatus(1);
          this.ques = new StateRegulationView({
            parent: this,
            model: m.get("question"),
          });
          break;
        case 4:
          this.updateStepStatus(2);
          this.ques = new PickDateView({
            parent: this,
            model: m.get("question"),
          });
          break;
        case 5:
          this.updateStepStatus(3);
          this.ques = new modelRequirementView({
            parent: this,
            model: m.get("question"),
          });
          break;
        case 6:
          this.ques = new modelDatailsView({
            parent: this,
            model: m.get("question"),
          });
          break;
        case 7:
          this.updateStepStatus(4);
          this.ques = new expansionKitsView({
            parent: this,
            model: m.get("question"),
          });
          break;
        case 8:
          this.updateStepStatus(5);
          this.ques = new finalSummaryView({
            parent: this,
            model: m.get("question"),
          });
          break;
        case 9:
          this.ques = new InPersonTrainingView({
            parent: this,
            model: m.get("question"),
          });
          break;
        case 10:
          this.ques = new ChooseProviderView({
            parent: this,
            model: m.get("question"),
          });
          break;
        case 11:
          this.ques = new CourseRequirmentView({
            parent: this,
            model: m.get("question"),
          });
          break;
        case 12:
          this.updateStepStatus(2);
          this.ques = new PickDateView({
            parent: this,
            model: m.get("question"),
          });
          break;
        case 13:
          this.updateStepStatus(2);
          this.ques = new PickDateView({
            parent: this,
            model: m.get("question"),
          });
          break;
        case 15:
          this.ques = new SpecifyCourseView({
            parent: this,
            model: m.get("question"),
          });
          break;
        default:
          break;
      }
      if (m.get("description") != "hide") {
        $(".section2").attr("style", "display:flex !important");
        this.desc
          .setElement(this.$("#DescribtionContainer"))
          .delegateEvents()
          .render();
      } else {
        $(".section2").attr("style", "display:none !important");
      }

      if (m.get("progress") != "hide") {
        $("#AppContainer").removeClass("no-summary-view");
        $("#SummaryView").show();
        this.progress
          .setElement(this.$("#SummaryView"))
          .delegateEvents()
          .render();
      } else {
        $("#AppContainer").addClass("no-summary-view");
        $("#SummaryView").hide();
      }

      this.ques.setElement(this.$("#QuestionsView")).delegateEvents().render();
      stepList.each(
        function (model) {
          var stepView = new StepsView({
            model: model,
          });
          // surfboard.render().el
          this.$("#StepsContainer").append(
            stepView.delegateEvents().render().el
          );
        }.bind(this)
      );
    },
  });
  //Description View
  var DescribtionView = Backbone.View.extend({
    // 'el' uses '#mydiv' as the view reference
    el: $("#DescribtionContainer"),

    // 'template' provides access to instance data when rendering the view
    template: _.template($("#DescribtionTpl").html()),

    // This function is called when the view is instantiated
    initialize: function () {
      // this.listenTo(this.model, "change", this.render);
    },

    // 'render' provides the logic required to construct the view
    render: function () {
      // console.log(this.model.attributes);
      this.$el.html(this.template(this.model));
    },
  });

  //Description View
  var StepsView = Backbone.View.extend({
    // 'template' provides access to instance data when rendering the view
    template: _.template($("#StepsTpl").html()),

    // This function is called when the view is instantiated
    initialize: function () { },
    events: {
      "click li": "setActive",
    },
    // 'render' provides the logic required to construct the view
    render: function () {
      this.$el.html(this.template(this.model.attributes));
      this.$el = this.$el.children();
      this.$el.unwrap();
      this.setElement(this.$el);
      return this;
    },
  });

  //Progress View
  var ProgressView = Backbone.View.extend({
    // 'template' provides access to instance data when rendering the view
    template: _.template($("#ProgressTpl").html()),

    // This function is called when the view is instantiated
    initialize: function () {
      this.listenTo(this.model, "change", this.render);
    },
    // 'render' provides the logic required to construct the view
    render: function () {
      var total = 0;
      //Add Modals to total price

      var modelR = steps.find(function (item) {
        return item.get("title") == "modal-requirment";
      });
      if (modelR) {
        total = total + Number(modelR.get("question")["total"]);
      }
      //Add Kits to total price
      modelR = steps.find(function (item) {
        return item.get("title") == "kits";
      });
      if (modelR) {
        total = total + Number(modelR.get("question")["total"]);
      }

      //Add Conversion courses
      modelR = steps.find(function (item) {
        return item.get("title") == "course-requirment";
      });
      if (modelR) {
        var cv = modelR.get("question");
        if (cv["value"]["handle"] == "conversion-course") {
          total = total + Number(cv["value"]["price"] / 100);
        }
      }
      //Add Course price
      modelR = steps.find(function (item) {
        var q = item.get("question");
        if (q["courseTier"]) {
          total = total + Number(q["total"]);
        }
      });
      this.model.set("totalPrice", total);
      // this.$el.unwrap();
      this.$el.html(this.template(this.model.attributes));
      return this;
    },
  });

  var BookingMySelfView = Backbone.View.extend({
    // 'template' provides access to instance data when rendering the view
    template: _.template($("#BookingMySelfTpl").html()),

    // This function is called when the view is instantiated
    initialize: function () {
      //  this.listenTo(this.model, "change", this.render);
    },
    events: {
      "click .check-box": "setActive",
      "click .next": "next",
    },
    setActive: function (e) {
      $(".check-box").removeClass("checked");
      $(e.currentTarget).addClass("checked");
      var v = $(e.currentTarget).attr("data-value");
      this.model["value"] = v;
      this.render();
    },
    next: function (e) {
      if (this.model["value"] == "1") {
        this.model["nextStepIndex"] = 2;
      } else {
        this.model["nextStepIndex"] = 1;
      }
      Backbone.trigger("next-event", this.model);
      e.stopPropagation();
    },
    // 'render' provides the logic required to construct the view
    render: function () {
      this.model.index = currentIndex;
      this.model.otherPerson = isBookingForSomeoneElse;
      this.$el.html(this.template(this.model));
      return this;
    },
  });

  var IntroductionPersonView = Backbone.View.extend({
    // 'template' provides access to instance data when rendering the view
    template: _.template($("#IntroductionPersonTpl").html()),

    // This function is called when the view is instantiated
    initialize: function () {
      //  this.listenTo(this.model, "change", this.render);
    },
    events: {
      "click .chip-filter": "setActive",
      "click .next": "next",
    },
    setActive: function (e) {
      this.model.index = this.index;
      var v = $(e.currentTarget).attr("data-value");
      if (!this.model["value"]) {
        this.model["value"] = [];
      }
      var ind = this.model["value"].indexOf(v);
      if (ind != -1) {
        this.model["value"].splice(ind, 1);
      } else {
        this.model["value"].push(v);
      }
      this.render();
    },
    next: function (e) {
      this.model["nextStepIndex"] = 3;
      Backbone.trigger("next-event", this.model);
      e.stopPropagation();
    },
    // 'render' provides the logic required to construct the view
    render: function () {
      this.model.index = currentIndex;
      this.model.otherPerson = isBookingForSomeoneElse;
      this.$el.html(this.template(this.model));
      return this;
    },
  });

  var StateRegulationView = Backbone.View.extend({
    // 'template' provides access to instance data when rendering the view
    template: _.template($("#StateRegulationsTpl").html()),

    // This function is called when the view is instantiated
    initialize: function () {
      //  this.listenTo(this.model, "change", this.render);
      this.model["stateLocations"] = [];
      for (var i in this.model.state.options) {
        this.model["stateLocations"].push(i);
        
      }
      //sort state locations in alphabetical order
      var data = this.model["stateLocations"].sort();

    },
    events: {
      "change .dropdown": "selectOption",
      "change .check-last": "lastOption",
      "change .check-agree": "agreeOption",
      "change .check-qualifications": "checkOption",
      "click .chip-filter": "setActive",
      "click .next": "next",
      "click .prev": "prev",
    },
    agreeOption: function (e) {
      if (e.target.checked) {
        this.model["qualifications"]["value"].push("agree");
      } else {
        var index = this.model["qualifications"]["value"].indexOf(
          e.target.value
        );
        if (index !== -1) {
          this.model["qualifications"]["value"].splice(index, 1);
        }
      }
      this.render();
    },
    lastOption: function (e) {
      if (e.target.checked) {
        this.model["qualifications"]["value"] = [];
        this.model["qualifications"]["value"].push("n/a");
      } else {
        this.model["qualifications"]["value"] = [];
      }
      this.render();
    },
    selectOption: function (e) {
      selectedState = e.target.value;
      selectedStateLabel = e.target[e.target.selectedIndex].text;
      this.model["state"]["value"] = e.target.value;
      this.model["qualifications"]["value"] = [];
      this.render();
    },
    checkOption: function (e) {
      var v = e.target.value;
      if (!this.model["qualifications"]["value"]) {
        this.model["qualifications"]["value"] = [];
      }
      if (this.model["qualifications"]["value"].includes("n/a")) {
        this.model["qualifications"]["value"] = [];
      }
      var ind = this.model["qualifications"]["value"].indexOf(v);
      if (ind != -1) {
        this.model["qualifications"]["value"].splice(ind, 1);
      } else {
        this.model["qualifications"]["value"].push(v);
      }
      this.render();
    },
    setActive: function (e) {
      var v = $(e.target).attr("data-value");
      if (!this.model["value"]) {
        this.model["value"] = [];
      }
      var ind = this.model["value"].indexOf(v);
      if (ind != -1) {
        this.model["value"].splice(ind, 1);
      } else {
        this.model["value"].push(v);
      }
      this.render();
    },
    prev: function (e) {
      Backbone.trigger("prev-event", this.model);
      e.stopPropagation();
    },
    next: function (e) {
      if (this.model.validated) {
        switch (lc.handle) {
          case "volume-enhanced-course":
            this.model["nextStepIndex"] = 9;
            break;
          case "classic-enhanced-course":
            this.model["nextStepIndex"] = 9;
            break;
          case "volume-course":
            this.model["nextStepIndex"] = 9;
            break;
          case "classic":
            this.model["nextStepIndex"] = 12;
            break;
          default:
            this.model["nextStepIndex"] = 4;
            break;
        }
        Backbone.trigger("next-event", this.model);
        e.stopPropagation();
      }
    },
    // 'render' provides the logic required to construct the view
    render: function () {
      this.model.index = currentIndex;
      this.model.otherPerson = isBookingForSomeoneElse;
      this.model["validated"] = false;

      if (this.model["qualifications"]["value"].length > 0) {
        if (
          this.model["qualifications"]["value"].includes("n/a") &&
          this.model["qualifications"]["value"].includes("agree")
        ) {
          this.model["validated"] = true;
        } else {
          this.model["validated"] = true;
        }
      }
      if (
        this.model.state.value &&
        this.model.state.options[this.model.state.value]["regulations"]
          .length == 0
      ) {
        this.model["validated"] = true;
      }
      this.$el.html(this.template(this.model));
      return this;
    },
  });

  var ExperienceLevelView = Backbone.View.extend({
    // 'template' provides access to instance data when rendering the view
    template: _.template($("#ExperienceLevelTpl").html()),

    // This function is called when the view is instantiated
    initialize: function () {
      //  this.listenTo(this.model, "change", this.render);
    },
    events: {
      "click .check-box": "setActive",
      "click .next": "next",
      "click .prev": "prev",
    },
    setActive: function (e) {
      $(".check-box").removeClass("checked");
      $(e.currentTarget).addClass("checked");
      var v = $(e.currentTarget).attr("data-value");
      this.model["value"] = v;
      this.render();
    },
    prev: function (e) {
      Backbone.trigger("prev-event", this.model);
      e.stopPropagation();
    },
    next: function (e) {
      Backbone.trigger("next-event", this.model);
      e.stopPropagation();
    },
    // 'render' provides the logic required to construct the view
    render: function () {
      this.model.index = currentIndex;
      this.model.otherPerson = isBookingForSomeoneElse;
      this.model.validated = false;
      if (this.model.value) {
        this.model.validated = true;
      }
      this.$el.html(this.template(this.model));
      return this;
    },
  });

  var InPersonTrainingView = Backbone.View.extend({
    // 'template' provides access to instance data when rendering the view
    template: _.template($("#InPersonTrainingTpl").html()),

    // This function is called when the view is instantiated
    initialize: function () {
      //  this.listenTo(this.model, "change", this.render);
    },
    events: {
      "click .check-box": "setActive",
      "click .next": "next",
      "click .prev": "prev",
    },
    setActive: function (e) {
      $(".check-box").removeClass("checked");
      $(e.currentTarget).addClass("checked");
      var v = $(e.currentTarget).attr("data-value");
      this.model["value"] = v;
      this.render();
    },
    prev: function (e) {
      Backbone.trigger("prev-event", this.model);
      e.stopPropagation();
    },
    next: function (e) {
      if (this.model.validated) {
        if (this.model.value == "1") {
          this.model["nextStepIndex"] = 10;
        } else {
          this.model["nextStepIndex"] = 11;
        }
        Backbone.trigger("next-event", this.model);
        e.stopPropagation();
      }
    },
    // 'render' provides the logic required to construct the view
    render: function () {
      this.model.index = currentIndex;
      this.model.otherPerson = isBookingForSomeoneElse;
      this.model.validated = false;
      if (this.model.value) {
        this.model.validated = true;
      }
      this.$el.html(this.template(this.model));
      return this;
    },
  });

  var ChooseProviderView = Backbone.View.extend({
    // 'template' provides access to instance data when rendering the view
    template: _.template($("#ChooseProviderTyp").html()),

    // This function is called when the view is instantiated
    initialize: function () {
      //  this.listenTo(this.model, "change", this.render);
    },
    events: {
      "change .dropdown": "onSelect",
      "click .next": "next",
      "click .prev": "prev",
      "focusout #otherName": "focusout",
      "change .check-agree": "agreeOption",
    },
    agreeOption: function (e) {
      if (e.target.checked) {
        this.model["certficationAgreement"] = true;
      } else {
        this.model["certficationAgreement"] = false;
      }
      this.render();
    },
    focusout: function (e) {
      var val = $(e.currentTarget).val();
      this.model["otherProvider"]["value"] = val;
      this.render();
    },
    onSelect: function (e) {
      this.model["provider"]["value"] = e.target.value;
      this.render();
    },
    next: function (e) {
      if (
        lc.handle == "classic-enhanced-course" ||
        lc.handle == "volume-course"
      ) {
        if (this.model["provider"]["value"] == "Lavish Lashes") {
          this.model["nextStepIndex"] = 4;
        } else {
          this.model["nextStepIndex"] = 11;
        }
      } else {
        this.model["nextStepIndex"] = 15;
      }

      Backbone.trigger("next-event", this.model);
      e.stopPropagation();
    },
    prev: function (e) {
      Backbone.trigger("prev-event", this.model);
      e.stopPropagation();
    },
    // 'render' provides the logic required to construct the view
    render: function () {
      this.model.index = currentIndex;
      this.model.otherPerson = isBookingForSomeoneElse;
      this.model.validated = false;
      if (
        this.model["provider"].value &&
        this.model["certficationAgreement"] == true
      ) {
        if (
          this.model["provider"].value == "Others" &&
          this.model["otherProvider"]["value"]
        ) {
          this.model.validated = true;
        } else {
          this.model.validated = true;
        }
      }
      this.$el.html(this.template(this.model));
      return this;
    },
  });

  var CourseRequirmentView = Backbone.View.extend({
    // 'template' provides access to instance data when rendering the view
    template: _.template($("#CourseRequirmentTpl").html()),

    // This function is called when the view is instantiated
    initialize: function () {
      this.model["multiple"] = false;
      var found = steps.find(function (item) {
        return item.get("title") === "previous-provider";
      });
      var c = steps.find((obj) => {
        return obj.get("title") == "inperson-training";
      });

      var s = steps.find((obj) => {
        return obj.get("title") == "specific-course";
      });
      //Classic / Volume Enhanced
      if (
        lc.handle == "classic-enhanced-course" ||
        lc.handle == "volume-course"
      ) {
        //Has gone through inpersoin training step
        if (c) {
          var q = c.get("question");
          // No Previous Training
          if (q.value == "2") {
            this.model["options"] = [];
            this.model["options"].push(cc);
          } else {
            // With Previous training not lavish
            if (found) {
              this.model["options"] = [];
              // this.model["options"].push(conc);
              this.model["options"].push(cc);
            }
          }
        }
      } else {
        this.model["options"] = [];
        if (s) {
          var q = s.get("question");
          if (q.mode == 0) {
            switch (q.value) {
              case "Classic Technique":
                // this.model["options"].push(conc);
                this.model["options"].push(vc);
                break;
              default:
                // this.model["options"].push(vconc);
                this.model["options"].push(vc);
                break;
            }
          }
        } else {
          this.model["value"] = [];
          // volume enhanced without training select all courses
          this.model["multiple"] = true;
          this.model["options"].push(cc);
          this.model["options"].push(vc);
        }
      }
      //  this.listenTo(this.model, "change", this.render);
    },
    events: {
      "click .check-box": "setActive",
      "click .next": "next",
      "click .prev": "prev",
    },
    setActive: function (e) {
      if (this.model["multiple"]) {
        $(e.currentTarget).addClass("checked");
        var v = $(e.currentTarget).attr("data-index");
        if (
          !this.model.value.filter((e) => e.id === this.model.options[v]["id"])
            .length > 0
        ) {
          this.model["value"].push(this.model["options"][v]);
        }
      } else {
        $(".check-box").removeClass("checked");
        $(e.currentTarget).addClass("checked");
        var v = $(e.currentTarget).attr("data-index");

        this.model["value"] = this.model["options"][v];
      }

      this.render();
    },
    prev: function (e) {
      Backbone.trigger("prev-event", this.model);
      e.stopPropagation();
    },
    next: function (e) {
      if (!this.model.multiple) {
        if (this.model.validated) {
          if (this.model.value) {
            if (this.model.value.handle != "conversion-course") {
              this.model["nextStepIndex"] = 12;
            } else {
              this.model["nextStepIndex"] = 4;
            }
          }
          Backbone.trigger("next-event", this.model);
          e.stopPropagation();
        }
      } else {
        if (this.model.validated) {
          this.model["nextStepIndex"] = 12;
          Backbone.trigger("next-event", this.model);
          e.stopPropagation();
        }
      }
    },
    // 'render' provides the logic required to construct the view
    render: function () {
      this.model.index = currentIndex;
      this.model.otherPerson = isBookingForSomeoneElse;
      this.model.validated = false;
      this.model.total = 0;
      if (!this.model.multiple && this.model.value) {
        this.model.validated = true;
        this.model.total = Number(this.model.value.price / 100);
      } else {
        if (this.model.multiple && this.model.value.length > 1) {
          this.model.validated = true;
          for (var i = 0; i < this.model.value.length; i++) {
            this.model.total =
              this.model.total + Number(this.model.value[i]["price"] / 100);
          }
        }
      }
      this.$el.html(this.template(this.model));
      return this;
    },
  });

  var SpecifyCourseView = Backbone.View.extend({
    // 'template' provides access to instance data when rendering the view
    template: _.template($("#SpecificCourseLavishTpl").html()),

    // This function is called when the view is instantiated
    initialize: function () {
      var found = steps.find(function (item) {
        return item.get("title") === "previous-provider";
      });
      //Classic / Volume Enhanced
      if (lc.handle == "volume-enhanced-course") {
        //Has gone through inpersoin training step
        if (found) {
          var q = found.get("question");
          // No Previous Training
          if (q.provider.value == "Lavish Lashes") {
            // FLAG : Show lavish courses
            this.model["mode"] = 1;
            this.model["courses"] = [];
            this.model["courses"].push(cc, vc);
          } else {
            // FLAG : Show other provider courses
            this.model["mode"] = 0;
            this.model["courses"] = [];
            this.model["courses"].push("Classic Technique", "Volume Technique");
          }
        }
      }
      //  this.listenTo(this.model, "change", this.render);
    },
    events: {
      "click .check-box": "setActive",
      "click .next": "next",
      "click .prev": "prev",
    },
    setActive: function (e) {
      $(".check-box").removeClass("checked");
      $(e.currentTarget).addClass("checked");
      var v = $(e.currentTarget).attr("data-index");
      if (v == this.model["courses"].length) {
        this.model["value"] = "both";
      } else {
        this.model["value"] = this.model["courses"][v];
      }

      this.render();
    },
    prev: function (e) {
      Backbone.trigger("prev-event", this.model);
      e.stopPropagation();
    },
    next: function (e) {
      if (this.model.validated) {
        if (this.model.mode == 1) {
          if (this.model.value.handle == "classic") {
            this.model["nextStepIndex"] = 4;
          } else {
            this.model["nextStepIndex"] = 13;
          }
        } else {
          this.model["nextStepIndex"] = 11;
        }
        Backbone.trigger("next-event", this.model);
        e.stopPropagation();
      }
    },
    // 'render' provides the logic required to construct the view
    render: function () {
      this.model.index = currentIndex;
      this.model.otherPerson = isBookingForSomeoneElse;
      this.model.validated = false;
      if (this.model.value) {
        this.model.validated = true;
      }
      this.$el.html(this.template(this.model));
      return this;
    },
  });

  var modelRequirementView = Backbone.View.extend({
    // 'template' provides access to instance data when rendering the view
    template: _.template($("#modelRequirementTpl").html()),

    // This function is called when the view is instantiated
    initialize: function () {
      this.model["noOfDays"] = 0;
      this.model["courses"] = [];
      var _this = this;
      steps.find(function (item) {
        var q = item.get("question");
        if (q.courseTier) {
          _this.model["courses"].push(q);
          _this.model["noOfDays"] = _this.model["noOfDays"] + 1;
        }
      });
      if (this.model["value"]["will-provide"].length == 0) {
        this.model["value"]["need"] = [];
        this.model["value"]["will-provide"] = [];
        for (var i = 0; i < this.model["noOfDays"]; i++) {
          this.model["value"]["need"].push(0);
          this.model["value"]["will-provide"].push(0);
        }
      }

      //  this.listenTo(this.model, "change", this.render);
    },
    events: {
      "click .need-event": "NeedModal",
      "click .will-provide": "WillProvide",
      "click .next": "next",
      "click .prev": "prev",
    },
    NeedModal: function (e) {
      var v = parseInt($(e.currentTarget).attr("data-value"));
      this.model["value"]["will-provide"][v] = 0;
      if (this.model["value"]["need"][v] == 1) {
        this.model["value"]["need"][v] = 0;
        this.model.courses[v]["course"]["model"]["qty"] = 0;
      } else {
        this.model["value"]["need"][v] = 1;
        this.model.courses[v]["course"]["model"]["qty"] = 1;
      }
      this.calculatePrice();
      this.render();
    },
    WillProvide: function (e) {
      var v = parseInt($(e.currentTarget).attr("data-value"));
      this.model["value"]["need"][v] = 0;
      if (this.model["value"]["will-provide"][v] == 1) {
        this.model["value"]["will-provide"][v] = 0;
      } else {
        this.model["value"]["will-provide"][v] = 1;
      }
      this.model.courses[v]["course"]["model"]["qty"] = 0;
      this.calculatePrice();
      this.render();
    },
    calculatePrice: function (e) {
      this.model.total = 0;
      for (var i = 0; i < this.model["value"]["need"].length; i++) {
        if (this.model["value"]["need"][i] == 1) {
          this.model.total =
            this.model.total +
            Number(this.model.courses[i]["course"]["model"]["price"] / 100);
        }
      }
      var totalEx = c.get("addOnPrices");
      var totalEx = Number(totalEx) + 1;
      c.set("addOnPrices", totalEx);
    },
    prev: function (e) {
      var c = steps.at(currentIndex - 2).toJSON();
      if (c) {
        c.question.value = "";
      }
      Backbone.trigger("prev-event", this.model);
      e.stopPropagation();
    },
    next: function (e) {
      this.model["nextStepIndex"] = 6;
      var c = stepsTemplate.find((obj) => {
        return obj.title == "modal-information";
      });
      if (c) {
        c["question"]["noOfModals"] = 0;
        c["question"]["startDate"] = this.model["startDate"];
        for (var i = 0; i < this.model["value"]["will-provide"].length; i++) {
          if (this.model["value"]["will-provide"][i] == 1) {
            c["question"]["noOfModals"] = c["noOfModals"] + 1;
          }
        }
        c["question"]["will-provide"] = this.model["value"]["will-provide"];
      }
      if (c["question"]["noOfModals"] == 0) {
        this.model["nextStepIndex"] = 7;
      }
      Backbone.trigger("next-event", this.model);
      e.stopPropagation();
    },
    // 'render' provides the logic required to construct the view
    render: function () {
      this.model.index = currentIndex;
      this.model.otherPerson = isBookingForSomeoneElse;
      this.model.validated = false;
      var total =
        this.model["value"]["need"].filter((x) => x == 1).length +
        this.model["value"]["will-provide"].filter((x) => x == 1).length;
      if (total == this.model.noOfDays) {
        this.model.validated = true;
      }
      this.$el.html(this.template(this.model));
      return this;
    },
  });

  var modelDatailsView = Backbone.View.extend({
    // 'template' provides access to instance data when rendering the view
    template: _.template($("#modelDetailsTpl").html()),

    // This function is called when the view is instantiated
    initialize: function () {
      this.model["courses"] = [];
      this.model["willProvideLater"] = false;
      var _this = this;
      steps.find(function (item) {
        var q = item.get("question");
        if (q.courseTier) {
          _this.model["courses"].push(q);
        }
      });
      if (this.model["value"].length == 0) {
        this.model["value"] = [];
        this.resetView();
      } else if (this.model["value"][0]["firstName"] == "") {
        this.model["value"] = [];
        this.resetView();
      }
    },
    resetView() {
      for (var i = 0; i < this.model["will-provide"].length; i++) {
        if (this.model["will-provide"][i] == 1) {
          var obj = {
            firstName: "",
            lastName: "",
            phoneNumber: "",
            email: "",
            isSame: false,
            day: i,
          };
          this.model["value"].push(obj);
        }
      }
    },
    events: {
      "change .txt-input": "textChange",
      "click .checkBox": "setActive",
      "click .next": "next",
      "click .prev": "prev",
      "click .checkSkip": "chkSkip",
    },
    textChange: function (e) {
      var val = $(e.currentTarget).val();
      var index = parseInt($(e.currentTarget).attr("data-index"));
      var name = $(e.currentTarget).attr("name");
      this.model["value"][index][name] = val;
      var f = this.model["value"].filter((obj) => {
        return obj.isSame;
      });
      f.forEach((element) => {
        element[name] = val;
      });
      this.render();
    },
    setActive: function (e) {
      var index = parseInt($(e.currentTarget).attr("data-index"));
      var obj = {
        firstName: this.model["value"][0].firstName,
        lastName: this.model["value"][0].lastName,
        phoneNumber: this.model["value"][0].phoneNumber,
        email: this.model["value"][0].email,
      };
      if (this.model["value"][index]["isSame"]) {
        this.model["value"][index]["isSame"] = false;
        obj = {
          firstName: "",
          lastName: "",
          phoneNumber: "",
          email: "",
          isSame: false,
        };
      } else {
        obj["isSame"] = true;
      }
      this.model["value"][index] = obj;
      this.render();
      // $(".checkBox").removeClass("checked")
      // $(e.currentTarget).addClass("checked");
      // var v = $(e.currentTarget).attr("data-value");
      // this.model["checkBox"]["value"]= v;
      // this.render();
    },

    prev: function (e) {
      Backbone.trigger("prev-event", this.model);
      e.stopPropagation();
    },
    next: function (e) {
      this.model["nextStepIndex"] = 7;
      Backbone.trigger("next-event", this.model);
      e.stopPropagation();
    },
    chkSkip: function (e) {
      if (this.model["willProvideLater"]) {
        this.model["willProvideLater"] = false;
      } else {
        this.model["willProvideLater"] = true;
      }
      this.render();
    },
    // 'render' provides the logic required to construct the view
    render: function () {
      this.model.index = currentIndex;
      this.model.otherPerson = isBookingForSomeoneElse;
      this.model.validated = true;
      if (!this.model["willProvideLater"]) {
        this.model["value"].forEach((element) => {
          if (
            !element["firstName"] ||
            !element["lastName"] ||
            !element["phoneNumber"] ||
            !element["email"]
          ) {
            this.model.validated = false;
          }
          if (
            !element["email"].match(
              /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            )
          ) {
            this.model.validated = false;
          }
          return;
        });
      }
      // this.model.validated = true
      // if(this.model["firstName1"]["value"] && this.model["lastName1"]["value"] && this.model["phoneNumber1"]["value"] && this.model["email1"]["value"]){
      //     this.model.validated = true
      //     if(this.model["checkBox"]["value"] == 1){
      //                  this.model.validated = true
      //         }  else if (this.model["firstName2"]["value"] && this.model["lastName2"]["value"] && this.model["phoneNumber2"]["value"] && this.model["email2"]["value"]){
      //                  this.model.validated = true
      //         }
      // }
      this.$el.html(this.template(this.model));
      $("input[name='phoneNumber']").mask("(999) 999-9999");
      return this;
    },
  });

  var expansionKitsView = Backbone.View.extend({
    // 'template' provides access to instance data when rendering the view
    template: _.template($("#expansionKitsTpl").html()),

    // This function is called when the view is instantiated
    initialize: function () {
      //  this.listenTo(this.model, "change", this.render);
      this.model["avlQty"] = 0;

      var currentCourse = JSON.parse(localStorage.getItem("current-course"));
      this.model["course_id"] = currentCourse.id;
    },

    events: {
      "change .qty": "qtyChange",
      "click .next": "next",
      "click .prev": "prev",
      "click .up": "up",
      "click .down": "down",
    },

    getKitAvl: async function () {
      return new Promise((resolve) => {
        var settings = {
          url: window.URL + "api/kits",
          method: "GET",
          timeout: 0,
          "Content-Type": "application/json",
        };
        var _this = this;
        $.ajax(settings).done(function (response) {
          if (response) {
            // _this.model["avlQty"] = 10;
            _this.model["avlQty"] = response.res[0].variants[0].inventory_quantity;
            resolve("resolved");
          }
        });

      });
    },

    up: async function (e) {
      await this.getKitAvl();
      var index = $(e.currentTarget).attr("data-index");
      var val = parseInt(this.model["items"][parseInt(index)]["qty"]);
      if (this.model["avlQty"] > 0) {
        val = val + 1;
      }

      if (val <= 0) {
        val = 0;
      } else if (val > this.model["avlQty"]) {
        val = this.model["avlQty"];
      }
      this.model["items"][parseInt(index)]["qty"] = parseInt(val);
      this.model.items.forEach((item) => {
        this.model["total"] = item.qty * Number(item.price / 100);
      });
      var totalEx = c.get("addOnPrices");
      var totalEx = Number(totalEx) + 1;
      c.set("addOnPrices", totalEx);
      this.render();
    },
    down: async function (e) {
      await this.getKitAvl();
      this.model["total"] = 0;
      var index = $(e.currentTarget).attr("data-index");
      var val = parseInt(this.model["items"][parseInt(index)]["qty"]);

      if (this.model["avlQty"] > 0) {
        val = val - 1;
      }

      if (val <= 0) {
        val = 0;
      } else if (val > this.model["avlQty"]) {
        val = this.model["avlQty"];
      }
      this.model["items"][parseInt(index)]["qty"] = parseInt(val);
      this.model.items.forEach((item) => {
        this.model["total"] = item.qty * Number(item.price / 100);
      });
      var totalEx = c.get("addOnPrices");
      var totalEx = Number(totalEx) + 1;
      c.set("addOnPrices", totalEx);
      this.render();
    },
    prev: function (e) {
      Backbone.trigger("prev-event", this.model);
      e.stopPropagation();
    },
    next: function (e) {
      this.model["nextStepIndex"] = 8;
      Backbone.trigger("next-event", this.model);
      e.stopPropagation();
    },
    // 'render' provides the logic required to construct the view
    render: async function () {
      await this.getKitAvl();
      this.model.index = currentIndex;
      this.model.otherPerson = isBookingForSomeoneElse;
      this.model.validated = false;
      // if(this.model["item1"]["value"] && this.model["item2"]["value"] && this.model["item3"]["value"]){
      //     this.model.validated = true
      // }
      if(savedData !== null ){
        if(c._previousAttributes.id == savedData.courseId && c._previousAttributes.startDate == savedData.startDate 
          && c._previousAttributes.startTime == savedData.startTime && c._previousAttributes.location == savedData.location){
          this.model["productOffers"] = savedData?.productOffers
          this.model["hasOffers"] = true
        } else{
          this.model["hasOffers"] = false
        }
      } else {
        this.model["hasOffers"] = false
      }
      this.$el.html(this.template(this.model));
      return this;
    },
  });

  var finalSummaryView = Backbone.View.extend({
    // 'template' provides access to instance data when rendering the view
    template: _.template($("#finalSummaryTpl").html()),

    // This function is called when the view is instantiated
    initialize: function () {
      this.model["value"] = [];
      for (var i = 0; i < steps.length; i++) {
        var m = steps.at(i).toJSON();
        if (m["title"] != "final-summary") {
          this.model["value"].push({
            attribute: m["title"],
            value: m["question"],
          });
        }
      }
      this.model["courses"] = [];
      var _this = this;
      var cr = [];
      steps.find(function (item) {
        var q = item.get("question");
        if (q["courseTier"]) {
          _this.model["courses"].push(q);
        }
        if (item.get("title") == "course-requirment") {
          if (
            q["value"]["handle"] == "conversion-course" ||
            q["value"]["handle"] == "volume-conversion-course"
          ) {
            // _this.model["courses"].push(q["value"])
            cr.push(q["value"]);
          }
        }
      });
      for (var i = 0; i < _this.model["courses"].length; i++) {
        for (var j = 0; j < cr.length; j++) {
          //courses[i].course.handle
        }
      }
      //  this.listenTo(this.model, "change", this.render);
    },
    modelR: null,
    kits: null,
    events: {
      "click .next": "next",
      "click .prev": "prev",
      "click .add-cart": "addToCart",
    },
    prev: function (e) {
      Backbone.trigger("prev-event", this.model);
      e.stopPropagation();
    },
    next: function (e) {
      Backbone.trigger("next-event", this.model);
      e.stopPropagation();
    },
    addToCart: function (e) {
      $("#loadingSpinner").attr("style", "display: flex !important");
      $("#btnCheckout").attr("style", "display: none !important");
      let formData = {
        items: [],
      };
      this.model["value"].filter(function (item) {
        if (item["value"]["courseTier"]) {
          formData.items.push({
            id: item["value"]["course"]["variants"][0].id,
            quantity: 1,
          });
          if (item["value"]["course"]["cv"]) {
            formData.items.push({
              id: item["value"]["course"]["cv"]["variants"][0].id,
              quantity: 1,
            });
          }
          if (item["value"]["course"]["model"]) {
            var modelQty = 0;
            var found = steps.find(function (item) {
              return item.get("title") === "modal-requirment";
            });
            if (found) {
              modelQty = found.attributes.question.courses[0].course.model.qty;
            }
            if (modelQty == 1) {
              formData.items.push({
                id: item["value"]["course"]["model"]["variants"][0].id,
                quantity: 1,
              });
            }
          }
        }
      });
      var k = this.kits.get("question");
      for (var i = 0; i < k["items"].length; i++) {
        if (k["items"][i]["qty"] > 0) {
          formData.items.push({
            id: k["items"][i].variants[0].id,
            quantity: k["items"][i]["qty"],
          });
        }
      }
      var _this = this;
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (response.status == 200) {
            _this.getCartToken();
          } else {
            console.log("Error Adding to cart");
          }
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },
    getCartToken: function () {
      var _this = this;
      var settings = {
        url: window.Shopify.routes.root + "cart.js",
        method: "GET",
        timeout: 0,
      };

      $.ajax(settings).done(function (response) {
        if (response) {
          _this.postEnrollmentData(response);
        }
      });
    },
    postEnrollmentData: function (data) {
      data = JSON.parse(data);
      var val = this.model["value"];
      var url = window.URL + "api/enrollment/create";
      var data = {
        token: data.token,
        userId: userId,
        enrollmentData: val,
        classInfo: lc,
      };
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          if (response) {
            window.location.href =
              location.protocol +
              "//" +
              location.host +
              window.Shopify.routes.root +
              "/cart";
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },
    // 'render' provides the logic required to construct the view
    render: function () {
      this.model.index = currentIndex;
      this.model.otherPerson = isBookingForSomeoneElse;
      var totalModelR = 0;
      var totalKit = 0;
      this.modelR = steps.find(function (item) {
        return item.get("title") == "modal-requirment";
      });
      if (this.modelR) {
        totalModelR =
          totalModelR + Number(this.modelR.get("question")["total"]);
      }

      this.kits = steps.find(function (item) {
        return item.get("title") == "kits";
      });
      if (totalKit) {
        totalKit = totalKit + Number(this.kits.get("question")["total"]);
      }
      var sClass = steps.find(function (item) {
        return item.get("title") == "pick-date";
      });
      this.model["totalKit"] = totalKit;
      this.model["kits"] = this.kits;
      this.model["models"] = this.modelR;
      this.model["totalModelR"] = totalModelR;
      this.model["courseFee"] = c.get("price");
      this.model["courseInfo"] = c;
      this.model["productOffers"] = this.model.kits._previousAttributes.question?.productOffers
      this.model["hasOffers"] = this.model.kits._previousAttributes.question?.hasOffers
      
      this.$el.html(this.template(this.model));
      return this;
    },
  });

  var otherPersonDetailView = Backbone.View.extend({
    // 'template' provides access to instance data when rendering the view
    template: _.template($("#otherPersonDetailsTpl").html()),

    // This function is called when the view is instantiated
    initialize: function () {
      //  this.listenTo(this.model, "change", this.render);
    },
    events: {
      "change .txt-input": "textChange",
      "click .next": "next",
      "click .prev": "prev",
    },

    textChange: function (e) {
      var val = $(e.currentTarget).val();
      var name = $(e.currentTarget).attr("name");
      this.model["value"][name] = val;

      this.render();
    },
    prev: function (e) {
      Backbone.trigger("prev-event", this.model);
      e.stopPropagation();
    },
    next: function (e) {
      this.model["nextStepIndex"] = 2;
      isBookingForSomeoneElse = this.model["value"]["firstName"];
      Backbone.trigger("next-event", this.model);
      e.stopPropagation();
    },
    // 'render' provides the logic required to construct the view
    render: function () {
      this.model.index = currentIndex;
      this.model.otherPerson = isBookingForSomeoneElse;
      this.model.validated = true;
      if (
        !this.model["value"]["firstName"] ||
        !this.model["value"]["lastName"] ||
        !this.model["value"]["phoneNumber"] ||
        !this.model["value"]["email"]
      ) {
        this.model.validated = false;
      }
      if (
        !this.model["value"]["email"].match(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
      ) {
        this.model.validated = false;
      }
      if (this.model["value"]["email"] == customerEmail) {
        this.model.validated = false;
      }
      this.$el.html(this.template(this.model));
      $("input[name='phoneNumber']").mask("(999) 999-9999");
      return this;
    },
  });

  var PickDateView = Backbone.View.extend({
    // 'template' provides access to instance data when rendering the view
    template: _.template($("#PickDateTpl").html()),
    courseSlots: [],
    todayDate: moment().format(),
    allLocations: ["New York", "Florida"],
    availableDays: [],
    calendarMonth: null,
    modelIsOpen: false,
    myModal: null,
    // This function is called when the view is instantiated
    initialize: function () {
      var stateData = steps.find(function (item) {
        return item.get("title") === "state-regulation";
      });
      if (stateData) {
        var q = stateData.get("question");
        this.getClasses()
        this.getAvailableStates();
        this.setLocation(q.state);
      }
    
      this.startDate = moment().format() ;
      var cv = null;
      var r = steps.find(function (item) {
        return item.get("title") == "course-requirment";
      });

      switch (this.model["courseTier"]) {
        case "first":
          switch (lc.handle) {
            case "classic-enhanced-course":
              this.model.course = cc;
              this.model["total"] = Number(cc.price / 100);
              if (r) {
                var cv = r.get("question");
                if (cv["value"]["handle"] == "conversion-course") {
                  this.model.course.cv = cv["value"];
                }
              }
              //Tier Two
              this.model["nextStepIndex"] = 4;
              
              break;
            case "volume-course":
              this.model.course = cc;
              this.model["total"] = Number(vc.price / 100);
              //Tier Two
              this.model["nextStepIndex"] = 4;
              if (r) {
                var cv = r.get("question");
                if (cv["value"]["handle"] == "conversion-course") {
                  this.model.course.cv = cv["value"];
                }
              }
              
              break;
            case "volume-enhanced-course":
              this.model.course = cc;
              this.model["total"] = Number(vc.price / 100);
              //Tier Two
              this.model["nextStepIndex"] = 4;
              break;
            default:
              this.model.course = cc;
              this.model["total"] = Number(cc.price / 100);
              //Model Requirement
              this.model["nextStepIndex"] = 5;
              this.getPreSelectedValues();
              
              break;
          }
          break;
        case "second":
          switch (lc.handle) {
            case "classic-enhanced-course":
              this.model.course = ce;
              this.model["total"] = Number(ce.price / 100);
              var f = steps.find(function (item) {
                var q = item.get("question");
                if (q.courseTier == "first") {
                  return item;
                }
              });
              if (f) {
                var q = f.get("question");
                this.startDate = moment(q["value"]["startDate"]).format();
              }
              if (r) {
                var cv = r.get("question");
                if (cv["value"]["handle"] == "conversion-course") {
                  this.model.course.cv = cv["value"];
                }
              }
              //Model Requirement
              this.model["nextStepIndex"] = 5;
              this.getPreSelectedValues();
              
              break;
            case "volume-course":
              this.model.course = vc;
              this.model["total"] = Number(vc.price / 100);
              if (r) {
                var cv = r.get("question");
                if (cv["value"]["handle"] == "conversion-course") {
                  this.model.course.cv = cv["value"];
                }
              }
              //Model Requirement
              this.model["nextStepIndex"] = 5;
              this.getPreSelectedValues();
              
              break;
            case "volume-enhanced-course":
              this.model.course = vc;
              this.model["total"] = Number(vc.price / 100);
              //Tier Three
              this.model["nextStepIndex"] = 13;

              
              break;
            default:
            
              break;
          }
          break;
        case "third":
          switch (lc.handle) {
            case "classic-enhanced-course":
              this.model.course = cc;
              this.model["total"] = Number(cc.price / 100);
              if (r) {
                var cv = r.get("question");
                if (cv["value"]["handle"] == "conversion-course") {
                  this.model.course.cv = cv["value"];
                }
              }
              //Model Requirement
              this.model["nextStepIndex"] = 5;

              
              break;
            case "volume-course":
              this.model.course = vc;
              this.model["total"] = Number(vc.price / 100);
              if (r) {
                var cv = r.get("question");
                if (cv["value"]["handle"] == "conversion-course") {
                  this.model.course.cv = cv["value"];
                }
              }
              //Model Requirement
              this.model["nextStepIndex"] = 5;
              this.getPreSelectedValues();
              
              break;
            case "volume-enhanced-course":
              this.model.course = ve;
              this.model["total"] = Number(ve.price / 100);
              //Model Requirement
              this.model["nextStepIndex"] = 5;
              this.getPreSelectedValues();
              break;
            default:
              break;
          }
          break;
        default:
          break;
      }
      this.model["filteredClasses"] = [];
    },
    startDate: null,
    getClasses: async function () {
      return new Promise((resolve) => {
        var settings = {
          url: window.URL + "api/class/find",
          method: "POST",
          timeout: 0,
          "Content-Type": "application/json",
          data: {
            startDate:  this.startDate,
            endDate: moment(this.startDate).endOf("month").format(),
            state: this.model["selectedLocation"],
            courseId: this.model["course"]["id"],
          },
        };
        var _this = this;

        $.ajax(settings).done(function (response) {
          if (response) {
            _this.model["filteredClasses"] = response.res;
            resolve("resolved");
          }
        });
      });
    },
    getAvailableStates: async function () {
      return new Promise((resolve) => {
        var settings = {
          url: window.URL + "api/class/state/find",
          method: "POST",
          timeout: 0,
          "Content-Type": "application/json",
          data: {
            courseId: this.model["course"]["id"],
          },
        };
        var _this = this;

        $.ajax(settings).done(function (response) {
          if (response) {
            _this.model["availableStates"] = [];
            for (var i = 0; i < response.res.length; i++) {
              var opt = stateLabels.find((obj) => {
                if (obj.value == response.res[i]["state"]) {
                  return obj;
                }
              });
              _this.model["availableStates"].push(opt);
            }

            //Sort selected list in map modal
            _this.model["availableStates"].sort((a, b) => {
              const nameA = a.name.toUpperCase(); // ignore upper and lowercase
              const nameB = b.name.toUpperCase(); // ignore upper and lowercase
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              // names must be equal
              return 0;
            });

            resolve("resolved");
          }
        });
      });
    },
    events: {
      "click .enabled": "selectDate",
      "touchstart .enabled": "selectDate",
      "click .next": "next",
      "click .prev": "prev",
      "click .open-modal": "openModal",
      "click .next-month": "nextMonth",
      "click .prev-month": "prevMonth",
      "click .today": "today",
      "change #selectLocation": "onLocationChange",
      "click .close": "closeModal",
      "click .book-slot": "bookSlot",
    },
    map: null,
    currentDate:  moment().format() ,
    today: function (e) {
      this.currentDate =   moment().format() ;
      this.render();
    },
    getPreSelectedValues: async function () {
      currentDate = (savedData === null) ?  moment().format() : moment(savedData.startDate).format() ;
      this.currentDate = (savedData === null) ?  moment().format() : moment(savedData.startDate).format();
      this.model["selectedClassSlot"] = (savedData === null) ?  [] : [savedData,];
      this.startDate = (savedData === null) ?  moment().format() : moment(savedData.startDate).format();
      this.model["selectedDate"] = (savedData === null) ? '' : savedData.startDate ;
    },
    onLocationChange: function (e) {
      this.model["selectedClassSlot"] = [];
      this.selectedLocation = e.target.value;
      this.model["selectedLocation"] = this.selectedLocation;
      this.model["selectedLocationLabel"] =
        e.target[e.target.selectedIndex].text;
      var c = this.model["classes"].filter((obj) => {
        return obj.location == this.selectedLocation;
      });
      this.model["filteredClasses"] = c;
      //this.changeMapMarker();
      this.render();
    },
    setLocation: function (data) {
      this.model["selectedLocation"] = stateLabels.find(function (item) {
        if (item.name == data.value) {
          return item;
        }
      });
      if (this.model["selectedLocation"]) {
        this.model["selectedLocation"] =
          this.model["selectedLocation"]["value"];
      }
      this.model["selectedLocationLabel"] = data.value;
      var c = this.model["classes"].filter((obj) => {
        return obj.location == this.model["selectedLocation"];
      });
      this.model["filteredClasses"] = c;
      //this.changeMapMarker();
      this.render();
    },

    closeModal: function (e) {
      this.modelIsOpen = false;
      this.model["modelIsOpen"] = this.modelIsOpen;
      this.render();
    },

    openModal: function (e) {
      this.modelIsOpen = true;
      this.model["modelIsOpen"] = this.modelIsOpen;
      this.render();
    },
    prev: function (e) {
      Backbone.trigger("prev-event", this.model);
      e.stopPropagation();
    },
    next: function (e) {
      c.set("startDate", this.model["value"]["startDate"]);
      c.set("startTime", this.model["value"]["startTime"]);
      c.set("location", this.model["value"]["location"]);
      Backbone.trigger("next-event", this.model);
      if (e) {
        e.stopPropagation();
      }
    },
    nextMonth: function () {
      this.currentDate = moment(this.currentDate).add(1, "month").format();
      var t = moment().format("MM");
      if (t != moment(this.currentDate).format("MM")) {
        this.currentDate = moment(this.currentDate).set("date", 1);
      }
      this.model["selectedDate"] =  " ";
      if (moment.isMoment(this.currentDate)) {
        this.startDate = this.currentDate.format();
      } else {
        this.startDate = this.currentDate;
      }

      this.sortClasses(this.currentDate);
      this.render();
    },
    prevMonth: function () {
      this.currentDate = moment(this.currentDate).subtract(1, "month").format();
      var t = moment().format("MM");
      if (t != moment(this.currentDate).format("MM")) {
        this.currentDate = moment(this.currentDate).set("date", 1);
      }
      this.model["selectedDate"] = "";
      if (moment.isMoment(this.currentDate)) {
        this.startDate = this.currentDate.format();
      } else {
        this.startDate = this.currentDate;
      }
      this.sortClasses(this.currentDate);
      this.render();
    },
    selectDate: function (e) {
      $(e.currentTarget).addClass("active");
      currentDate = moment($(e.currentTarget).attr("data-date")).format();
      this.model["selectedDate"] = currentDate;
      this.sortClasses(currentDate);
      this.render();
    },
    bookSlot: function (e) {
      var i = $(e.currentTarget).attr("data-id");
      var c = this.model["filteredClasses"].find((obj) => {
        return obj._id == i;
      });
      if (i) {

        this.model["value"] = c;
        this.closeModal();
        this.next();

      }
    },
    sortClasses: function (date) {
      this.model["selectedClassSlot"] = [];
      for (var i = 0; i < this.model["filteredClasses"].length; i++) {
        if (
          moment(this.model["filteredClasses"][i]["startDate"]).format(
            "yyyy/MM/DD"
          ) == moment(date).format("yyyy/MM/DD")
        ) {
          this.model["selectedClassSlot"].push(
            this.model["filteredClasses"][i]
          );
        }
      }
    },
    loadDates: function () {
      var dates = [];
      var todayDate = moment(this.currentDate).format();
     var startOfTheMonth = moment(this.currentDate).startOf("month").format();
      var noOfDays = parseInt( 
        moment(this.currentDate).endOf("month").format("D")
      );
      var content = "";
      var firstDayOfWeek;
      var date = startOfTheMonth;
      var dayOfTheWeek = moment(startOfTheMonth).isoWeekday();

     currentMonth = moment(this.currentDate).format("MM");
      var eventBooked;
      for (var i = 0; i < noOfDays + dayOfTheWeek - 1; i++) {
        if (i == 0) {
          firstDayOfWeek = moment(startOfTheMonth).startOf("isoWeek").format();
        }
        date = moment(firstDayOfWeek).add("days", i).format();
        var extraClass = "";
        var currentDateFormated = moment(this.currentDate).format("yyyy/MM/DD");
        var dateFormated = moment(date).format("yyyy/MM/DD");
        var iMonth = moment(date).format("MM");
        if (moment(currentDateFormated).isSame(dateFormated)) {
          // extraClass += "today";
        }
        if (iMonth !== currentMonth) {
          extraClass += " prev-month";
        }
        if (moment(date).isBefore(todayDate)) {
          extraClass += " disabled";
        }
        eventBooked = false;

        if (
          moment(this.model["selectedDate"]).format("yyyy/MM/DD") ==
          dateFormated
        ) {
          extraClass += " active";
        }
        for (var a = 0; a < this.model["filteredClasses"].length; a++) {
          var startDate = moment(
            this.model["filteredClasses"][a]["startDate"]
          ).format("yyyy/MM/DD");
          if (startDate == dateFormated) {
            extraClass += " enabled";
          }
        }
        dates.push({
          extraClass: extraClass,
          date: moment(date).format("yyyy/MM/DD"),
          label: moment(date).format("DD"),
        });
        this.model["dates"] = dates;
        this.model["dateFormated"] = "adwdw";
        this.model["allLocations"] = this.allLocations;
        //content += '<div class="date ' + extraClass + '" data-date="' + moment(date).format("yyyy/MM/DD") + '"><span>' + moment(date).format("DD") + '</span></div>'
      }
    },
    changeMapMarker: async function () {
      var mapProp = {
        zoom: 7,
        fullscreenControl: false,
        zoomControl: false,
        scaleControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        rotateControl: true,
        styles,
      };
      this.map = new google.maps.Map(
        document.getElementById("googleMap"),
        mapProp
      );

      var request = {
        query: this.model["selectedLocationLabel"],
        fields: ["name", "geometry"],
      };


      var service = new google.maps.places.PlacesService(this.map);
      var _this = this;
      service.findPlaceFromQuery(request, function (results, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          for (var i = 0; i < results.length; i++) {
            _this.createMarker(results[i]);
          }
          _this.map.setCenter(results[0].geometry.location);
        }
      });
    },
    createMarker: function (place) {
      new google.maps.Marker({
        position: place.geometry.location,
        map: this.map,
      });
    },
    // 'render' provides the logic required to construct the view
    render: async function () {
      this.model.index = currentIndex;
      if (!this.model["selectedLocation"]) {
        await this.getAvailableStates();
      }
      if (
        this.model["selectedLocation"] &&
        this.model["selectedLocationLabel"]
      ) {
        await this.getClasses();
      }
      this.model.otherPerson = isBookingForSomeoneElse;
      this.model["currentDate"] = this.currentDate;
      // if (this.model["value"]) {
      //   this.next();
      // }
      this.loadDates();
      this.$el.html(this.template(this.model));
      if (
        this.model["selectedLocation"] &&
        this.model["selectedLocationLabel"]
      ) {
        await this.getClasses();
        await this.changeMapMarker();
      }

      if (selectedState && this.model["selectedLocationLabel"]) {
        await this.getClasses();
        await this.changeMapMarker();
      }

      return this;
    },
  });

  async function init() {
    await getStates();
    await getModelProductDetails();

    var c = stepsTemplate.find((obj) => {
      return obj.title == "state-regulation";
    });
    var m = stepsTemplate.find((obj) => {
      return obj.title == "modal-requirment";
    });
    if (m) {
      m["question"]["modal"] = JSON.parse(modal);
    }
    if (c) {
      for (var i = 0; i < states.length; i++) {
        var opt = stateLabels.find((obj) => {
          if (obj.value == states[i]["state"]) {
            return obj;
          }
        });
        if (opt) {
          var r = (c["question"]["state"]["options"][opt.name] = {
          regulations: [],
        });
        states[i]["esthetician"]
          ? r.regulations.push("Esthetician license")
          : false;
        states[i]["medical"] ? r.regulations.push("Medical license") : false;
        states[i]["other"] ? r.regulations.push(states[i]["other"]) : false;
        states[i]["cosmetologist"]
          ? r.regulations.push("Cosmetologist license")
          : false;
        }
      }
    }
    var addOnsList = stepsTemplate[7]["question"]["addOns"];
    for (var i = 0; i < addOnsList.length; i++) {
      var v = await getAddonProducts(addOnsList[i]);
      if (v) {
        v = JSON.parse(v);
        v["qty"] = 0;
      }
      stepsTemplate[7]["question"]["items"].push(v);
    }

    new ApplicationView();
  }
  init();
});
